export default __webpack_public_path__ + "static/start-foreground-772b824d338532cc4407d53e6bedfbdf.png";